export class ERPInput {
    public name: string = '';
}
